import React, { useMemo } from "react";
import type { SimAvailabilityData } from "app/pages/Customer/Activation/slice/types";
import { ActivationCongratulationsDialogView } from "./activation-congratulations-dialog-view";
import { buildActivationCodeCongratulationsRows } from "./activation-code-flow";
import { useActivationCodeCongratulationsContinue } from "./use-activation-code-congratulations-continue";

interface Props {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  data?: SimAvailabilityData;
}

export const ActivationCodeCongratulationsDialog = ({
  showDialog,
  setShowDialog,
  data,
}: Props) => {
  const rows = useMemo(
    () => buildActivationCodeCongratulationsRows(data),
    [data]
  );

  const { handleContinue, continueDisabled } =
    useActivationCodeCongratulationsContinue({
      data,
      showDialog,
      setShowDialog,
    });

  return (
    <ActivationCongratulationsDialogView
      showDialog={showDialog}
      setShowDialog={setShowDialog}
      description="Your devices are compatible for VLE Mobile services."
      rows={rows}
      onContinue={handleContinue}
      continueDisabled={continueDisabled}
    />
  );
};
